import React from "react"
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"
// import errorMessages, {generalErrorMessage} from "../config/errorMessages"

const ErrorDialog = ({isOpen, toggle, /*message*/}) => {
  // const getErrorMessage = errorMessages.find((errorMessage) => errorMessage.apiError === message)?.message
  const generalErrorMessage = 'We are unable to process your request at the moment. Please try again later.'

  return <>
    <Modal isOpen={isOpen} toggle={toggle}  className="contact">
      <ModalHeader toggle={toggle}>An error occured!</ModalHeader>
      <ModalBody>
        {/*getErrorMessage ||*/ generalErrorMessage}
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => toggle()}>Ok</Button>
      </ModalFooter>
    </Modal>
  </>
}

export default ErrorDialog